// מעטפת שמייבאת CSS ממוקד ללומד בלבד, כדי לא לגעת ב-Admin
import './learning.css';

export default function LearningShell({ children }) {
  return <div className="lt-root">{children}</div>;
}
